import React from "react";
import SubcontractorPurchaseInvoiceSummaryTable from "../subcontractorPurchaseInvoiceSummaries/components/SubcontractorPurchaseInvoiceSummaryTable";
import HeaderContent from "../../components/layout/components/HeaderContent";

const SubcontractorPurchaseInvoicesList = () => {
  const breadcrumb = [
    {
      link: "/subcontractorPurchaseInvoices",
      title: "Subcontractor Purchase Invoices",
    },
  ];

  return (
    <>
      <HeaderContent
        breadcrumb={breadcrumb}
        headerTitle="Subcontractor Purchase Invoices"
        isNotHaveSchoolFilter
      />

      <SubcontractorPurchaseInvoiceSummaryTable
        referenceResource="subcontractorPurchaseInvoices"
        isShowTitle
      />
    </>
  );
};

export default SubcontractorPurchaseInvoicesList;
